import React from 'react'
import { SaleLotCategory } from '@sales/data/lots/categories/LotCategoryData';
import { SaleLot } from '@sales/data/lots/LotData';
import { useLotCategorySelectionProps } from './LotCategoryLookup';
import AgTechFormLookup from '@agtech/web/components/Forms/Controls/Lookups/AgTechFormLookup';

export type LotCategoryGridLookupProps = {
    lot: SaleLot,
    onLotCategorySelected: (selectedLotCategory?: SaleLotCategory) => Promise<any>
}

const LotCategoryGridLookup = (props: LotCategoryGridLookupProps) => {
    const lotCategorySelectionProps = useLotCategorySelectionProps({
        entityType: props.lot,
        getSelectedLotCategoryId: () => props.lot.lotCategoryId,
        onLotCategorySelected: async (e, sel) => await props.onLotCategorySelected(sel)
    });

    return (
        <AgTechFormLookup
            {...lotCategorySelectionProps}
            control={{
                caption: ''
            }}
            style={'grid'}
        />
    );
}

export default LotCategoryGridLookup